<template>
  <v-card class="my-auto mx-auto">
    <div class="card-info card-info-text">
      <p class="mb-0">
        {{ $t("Showing") }} {{ usersFiltered.length }} {{ $t("suggestions") }}
      </p>
      <p v-if="noUsersFound" style="font-weight: normal">
        {{ $t("No users were found") }}
      </p>
    </div>
    <v-list flat class="user-list-container">
      <v-list-item-group>
        <v-list-item
          v-for="(user, i) in usersFiltered"
          :key="i"
          class="user-card"
          @click="tagUser(user)"
        >
          <v-list-item-icon>
            <div
              class="user-avatar"
              :style="{ backgroundColor: userColor(user) }"
            >
              <p class="user-avatar-inner">
                {{ user.name[0].toUpperCase()
                }}{{ user.surname[0].toUpperCase() }}
              </p>
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <div class="user-info">
              <div class="user-name">{{ user.name }} {{ user.surname }}</div>
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>

export default {
    name: 'CommentUsersList',
    props: {},
    data() {
        return {
            open: false,
            usersFiltered: [],
            noUsersFound: false,
            users: [],
        };
    },
    computed: {
        userColor() {
            return function (user) {
                // Generate a random color once for each user
                if (!Object.prototype.hasOwnProperty.call(user, 'color')) {
                    user.color = this.getRandomColor();
                }
                return user.color;
            };
        },
    },
    methods: {
        tagUser(user) {
            const userTagged = {
                id: user.id,
                name: user.name,
                surname: user.surname,
            };

            this.$emit('userTagged', userTagged);
            this.open = false;
            this.usersFiltered = this.users;
            this.noUsersFound = false;
        },
        filterUsers(commentText) {
            if (commentText && this.users) {
                commentText = commentText.replace('@', '');
                this.usersFiltered = this.users.filter(
                    (user) =>
                        user.name.toLowerCase().includes(commentText.toLowerCase()) ||
                        user.surname.toLowerCase().includes(commentText.toLowerCase())
                );
                if (this.usersFiltered.length == 0) {
                    this.noUsersFound = true;
                } else this.noUsersFound = false;
            } else {
                if (this.users) {
                    this.usersFiltered = this.users.slice(0, 20);
                    this.noUsersFound = false;
                }
            }
        },
        loadUsers(users) {
            this.users = users;
        },
        getRandomColor() {
            var minSaturation = 35;
            var maxSaturation = 75;
            var minLightness = 30;
            var maxLightness = 70;

            var saturation =
                Math.floor(Math.random() * (maxSaturation - minSaturation + 1)) +
                minSaturation;
            var lightness =
                Math.floor(Math.random() * (maxLightness - minLightness + 1)) +
                minLightness;

            var saturationPercent = saturation + '%';
            var lightnessPercent = lightness + '%';

            var color =
                'hsl(' +
                Math.floor(Math.random() * 360) +
                ',' +
                saturationPercent +
                ',' +
                lightnessPercent +
                ')';

            return color;
        },
    },
};
</script>

<style scoped>
.v-list-item__content {
  margin: 0px;
  padding: 0px;
}

.v-list {
  padding: 0px;
}

.v-list-item__icon {
  margin: 0px !important;
}

.card-info-text {
  font-size: 15px;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 0px;
  margin-left: 10px;
  margin-right: 10px;
}

.user-card {
  background-color: #fff;
  display: flex;
  align-items: center;
  width: 100%;
  cursor: pointer;
}

.user-card:hover {
  background-color: #e0e0e0;
}

.user-info {
  flex: 1;
  line-height: normal;
}

.user-name {
  font-weight: bold;
  font-size: 15px;
}

.user-avatar {
  display: inline-block;
  margin: 10px;
  border-radius: 50%;
}

.user-avatar-inner {
  color: white;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  text-decoration: none;
  height: 35px;
  width: 35px;
  font-size: 14px;
}

.user-list-container {
  max-height: 121px !important;
  overflow-y: auto !important;
}
</style>
